<template>
  <LayoutType
    v-if="store.formId"
    :widget-name="widgetName"
    :widget-id="widgetId"
    :form-style="store.formStyle"
    :form-name="store.builder.name"
    :base-url="store.integrate.baseUrl"
    :is-white-labelled="store.integrate.isWhiteLabelled"
    :form-layout-settings="store.integrate.formLayoutSettings"
  ></LayoutType>
  <BasicEmbed
    v-else
    :is-white-labelled="store.integrate.isWhiteLabelled"
    :name="store.builder.name"
    :widget-name="widgetName"
    :widget-id="widgetId"
    :base-url="store.integrate.baseUrl"
  ></BasicEmbed>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { useI18n } from "vue-i18n";
import BasicEmbed from "./BasicEmbed.vue";
import LayoutType from "./LayoutType.vue";

const { t } = useI18n();
const store = useAppStore();

const props = defineProps({
  widgetName: {
    type: String,
    required: true,
  },
  widgetId: {
    type: String,
    required: true,
  },
});
</script>
